import axios from 'axios'

const RESET = 'RESET'
const BASE_URL = 'api/Administration/AquariusStations'
const FETCH_STATIONS_URL = `${BASE_URL}`
const SOFT_DELETE_STATION_URL = (id) => `${BASE_URL}/${id}`
const HARD_DELETE_STATION_URL = (id) => `${BASE_URL}/${id}/HardDelete`

const SET_STATIONS = 'SET_STATIONS'
const SET_SERVICE = 'SET_SERVICE'
const UPDATE_STATION = 'UPDATE_STATION'
const REMOVE_STATION = 'REMOVE_STATION'

import {
  SERVICE_LINKS,
} from '@/store/ServiceRegistry/linkedservices'

const initialState = () => ({
  aquariusSynchronizer: null,
  stations: [],
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async fetchStations({
      commit,
    }) {
      try {
        let response = await axios.get(FETCH_STATIONS_URL)
        let stations = response.data
        commit(SET_STATIONS, stations)
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async softDeleteStation({
      commit,
    }, station) {
      try {
        await axios.delete(SOFT_DELETE_STATION_URL(station.Id))
        station.IsDeleted = true
        commit(UPDATE_STATION, station)
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async hardDeleteStation({
      commit,
    }, station) {
      try {
        await axios.delete(HARD_DELETE_STATION_URL(station.Id))
        station.IsDeleted = true
        commit(REMOVE_STATION, station)
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async archiveStationToTsDb({
      commit,
      dispatch,
    }, {service, station}) {
      try {
        console.log('start archive station ' + station)
        var syncOptions = {
          ArchiveStationGuid: station.AquariusId,
        }
        try {
          let result = await dispatch('services/executeService', {
            serviceId: service.Id,
            defaultTimeout: 3600, // Modify the default timeout to an hour because requests can take a long time
            data: syncOptions,
          }, {
            root: true,
          })
          station.IsArchived = true
          commit(UPDATE_STATION, station)
          return result
        } catch (e) {
          console.error(e)
          throw e
        }
        //await axios.delete(HARD_DELETE_STATION_URL(station.Id))
        //station.IsDeleted = true
        //commit(REMOVE_STATION, station)
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async fetchService({
      commit,
      dispatch,
    }) {
      try {
        let aquariusSynchronizer = await dispatch('linkedservices/getServiceByLink', {
          serviceLink: SERVICE_LINKS.AQUARIUS_SYNCHRONIZER,
        }, {
          root: true,
        })

        commit(SET_SERVICE, aquariusSynchronizer)
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async synchronize({
      dispatch,
    }, {
      serviceId,
      service,
      syncOptions,
    }) {
      try {
        let result = await dispatch('services/executeService', {
          serviceId: serviceId || service.Id,
          defaultTimeout: 3600, // Modify the default timeout to an hour because requests can take a long time
          data: syncOptions,
        }, {
          root: true,
        })

        return result
      } catch (e) {
        console.error(e)
        throw e
      }
    },
  },
  mutations: {
    [SET_STATIONS](state, stations) {
      state.stations = stations
    },
    [UPDATE_STATION](state, station) {
      let index = state.stations.findIndex(stn => stn.Id == station.Id)
      if (index < 0) return

      state.stations.splice(index, 1, station)
    },
    [REMOVE_STATION](state, station) {
      let index = state.stations.findIndex(stn => stn.Id == station.Id)
      if (index < 0) return

      state.stations.splice(index, 1)
    },
    [SET_SERVICE](state, aquariusSynchronizer) {
      state.aquariusSynchronizer = aquariusSynchronizer
    },
    [RESET](state) {
      state.configurations = initialState.configurations
    },
  },
  getters: {
    stations: (state) => state.stations,
    aquariusSynchronizer: (state) => state.aquariusSynchronizer,
  },
}